export const MAPS = {
    KEY: 'AIzaSyAK0UC-aEr68h1RX7BT6jvM1dQXZHQMq8g',
}

export const ONESIGNAL = {
    APP_ID: '92a6fc17-75ce-4b77-b397-bd33dbcf7c67',
}
